export * from "-!../../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--1!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./scratchwork.vue?vue&type=template&id=0e35d546&scoped=true&"


//////////////////
// WEBPACK FOOTER
// ./src/views/scratchwork/scratchwork.vue?vue&type=template&id=0e35d546&scoped=true&
// module id = null
// module chunks = 